import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useForm, useWatch } from 'react-hook-form';
import { Link, useParams } from 'react-router-dom';
import { AuthContext } from '../../../auth';
import { SYSTEM_CREATE, SYSTEM_UPDATE } from '../../../mutations';
import Drawing from './Drawing';
import Form from './Form';
import Header from './Header';
import { useInitialValues, useOnSubmit, useTwoJs } from './lib';

const SgdForm = ({
  systemId,
  marks,
  glassCompositions,
  frameColors,
  markups,
}) => {
  const isNew = !systemId;
  const { two, twoElem, getImage } = useTwoJs();
  const { currentUser } = useContext(AuthContext);
  const params = useParams();
  const formContext = useForm({
    mode: 'onBlur',
    defaultValues: {
      estimateId: params.estimateId,
      qty: 1,
      autoPrice: true,
    },
  });
  const glassCompositionId = useWatch({
    control: formContext.control,
    name: 'glassCompositionId',
  });

  const onSubmit = useOnSubmit({
    getImage,
    mutation: isNew ? SYSTEM_CREATE : SYSTEM_UPDATE,
    estimateId: params.estimateId,
  });
  useInitialValues({ systemId, formContext });

  const filteredGlassCompositions = currentUser.internal
    ? glassCompositions
    : glassCompositions.filter(
        ({ id, glassOnly }) => !glassOnly || id === glassCompositionId
      );

  return (
    <Row className="system-form">
      <Col xs={3} className="d-flex flex-column">
        <Header isNew={isNew} />
        <div className="form-container">
          <div className="fixed">
            <Form
              context={formContext}
              marks={marks}
              glassCompositions={filteredGlassCompositions}
              frameColors={frameColors}
              markups={markups}
            />
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-block mt-4"
          onClick={formContext.handleSubmit(onSubmit)}
        >
          Save
        </button>
        <Link
          to={`/estimates/${params.estimateId}`}
          className="btn btn-outline-secondary btn-block"
        >
          Cancel
        </Link>
      </Col>
      <Col xs={9} className="d-flex">
        <Drawing formContext={formContext} two={two} twoElem={twoElem} />
      </Col>
    </Row>
  );
};

SgdForm.defaultProps = {
  systemId: '',
};

SgdForm.propTypes = {
  systemId: PropTypes.string,
  marks: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SgdForm;
